import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridSortModel,
  GridCellParams,
  MuiEvent,
  GridCallbackDetails,
} from "@mui/x-data-grid";
import { Box, Stack, Typography } from "@mui/material";
import { adsBlueA, adsLightGreyB, adsLightGreyC, adsMidGreyA, adsWhite } from "../utils/ADSColours";

interface AADataTableProps {
  columnData: GridColDef[];
  rowData: any[];
  handleDoubleClick?: (
    params: GridCellParams,
    event: MuiEvent<React.MouseEvent<HTMLElement, MouseEvent>>,
    details: GridCallbackDetails
  ) => void;
  sortCol?: GridSortModel;
  updateSortCol?: (model: GridSortModel) => void;
}

const AADataTable: React.FC<AADataTableProps> = ({
  columnData,
  rowData,
  handleDoubleClick,
  sortCol,
  updateSortCol,
}) => {
  const [sortModel, setSortModel] = useState<GridSortModel>(sortCol || []);

  const handleSortChange = (model: GridSortModel) => {
    // Prevent infinite loop by checking if the sort model is different
    if (JSON.stringify(model) !== JSON.stringify(sortModel)) {
      setSortModel(model);
    }
  };

  useEffect(() => {
    if (updateSortCol) updateSortCol(sortModel);
  }, [sortModel, updateSortCol]);

  return (
    <div style={{ height: "95%", width: "100%" }}>
      <Stack
        sx={{
          backgroundColor: adsWhite,
          color: adsMidGreyA,
          borderBottom: `0px solid ${adsLightGreyB}`,
        }}
      >
        <Typography variant="subtitle2" sx={{ color: adsBlueA }}>
          Users
        </Typography>
      </Stack>
      <div style={{ display: "flex", height: "100%" }}>
        <div style={{ flexGrow: 1 }}>
          <Box
            sx={{
              height: "100%",
              mb: "26px",
              "& .data-grid-header": {
                backgroundColor: adsLightGreyC,
                color: adsMidGreyA,
              },
              "& .MuiDataGrid-iconSeparator": { display: "none" },
            }}
          >
            <DataGrid
              rows={rowData || []}
              columns={columnData || []}
              autoPageSize
              disableColumnMenu
              disableColumnSelector
              disableDensitySelector
              hideFooterSelectedRowCount
              density="compact"
              editMode="row"
              pagination
              onCellDoubleClick={(
                params: GridCellParams,
                event: MuiEvent<React.MouseEvent<HTMLElement, MouseEvent>>,
                details: GridCallbackDetails
              ) => {
                if (handleDoubleClick) handleDoubleClick(params, event, details);
                if (!event.ctrlKey) {
                  (event as any).defaultMuiPrevented = true;
                }
              }}
              sortModel={sortModel}
              onSortModelChange={(model) => handleSortChange(model)}
            />
          </Box>
        </div>
      </div>
    </div>
  );
};

export default AADataTable;
